import type { BlobLike } from "@pdfking/compatibility"
import type { Sequence } from "@pdfking/tfunc"
import type { Rectangle } from "../geometry/Rectangle"
import type { Pixel } from "../units/Units"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type PDFRasterizeResult = {
  blob: BlobLike
  size: Rectangle<Pixel>
}

export type PDFRasterizeFunction = (
  input: PDFReaderOptions,
  image_resolution?: Pixel,
  rangeFn?: (page_count: number) => Sequence<number>
) => AsyncGenerator<PDFRasterizeResult>
